import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResponsiveContainer, ResponsiveContent, ResponsiveHeader, ResponsiveFooter } from '../ui/ResponsiveLayout';
import { ENABLE_BENEFICIARY_PORTAL } from '../../config/planAccessConfig';
const Frame301: React.FC = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate('/frame-302');
  };

  const handleBack = () => {
    navigate('/frame-140');
  };

  return (
    <ResponsiveContainer background="stone">
      <ResponsiveContent>
        <ResponsiveHeader
          title="Confirm Plan Access"
        />

        <div className="max-w-4xl space-y-8">
          {/* Introduction */}
          <div className="space-y-4">
            <p className="text-stone-800 text-lg font-medium font-['Work_Sans'] leading-relaxed">
            Taking time to review who can access your plan helps ensure clarity and continuity for the people you trust. This step makes it clear who can view or manage information if it’s ever needed, and helps avoid confusion later.
            </p>
            <p className="text-stone-800 text-lg font-medium font-['Work_Sans'] leading-relaxed">
                You don’t need to invite anyone right now. You can move at your own pace, skip steps, and update access whenever you’re ready.
                </p>
          </div>

          {/* What You'll Do Section */}
          <div className="bg-white rounded-lg border border-neutral-200 p-6">
            <h2 className="text-xl font-semibold text-cyan-900 mb-4">What You'll Do</h2>
            <div className="space-y-4">
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  1
                </div>
                <div>
                  <h3 className="font-semibold text-stone-800 mb-1">Review who currently has access to your plan</h3>

                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  2
                </div>
                <div>
                  <h3 className="font-semibold text-stone-800 mb-1">Confirm and invite your executor to securely access the plan</h3>
                </div>
              </div>

              {ENABLE_BENEFICIARY_PORTAL && (
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  3
                </div>
                
                <div>
                  <h3 className="font-semibold text-stone-800 mb-1">Optionally invite beneficiaries to view limited, planning-only information</h3>
                </div>
              </div>
              )}
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  {ENABLE_BENEFICIARY_PORTAL ? 4 : 3}
                </div>
                <div>
                  <h3 className="font-semibold text-stone-800 mb-1">Review a summary of plan access in one place</h3>
                </div>
              </div>
            </div>
          </div>

          {/* Why This Matters */}
          <div className="bg-cyan-50 border border-cyan-100 rounded-lg p-6">
            <h2 className="text-lg font-semibold text-cyan-900 mb-3">Why This Matters</h2>
            <ul className="space-y-2 text-stone-700">
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>Ensures the right people can access the right information</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>Reduces uncertainty about who has visibility into your plan</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>Keeps access intentional, controlled, and reviewable</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>Makes it easier to update or change access over time</span>
              </li>
            </ul>
          </div>

          {/* Time Estimate */}
          <div className="text-center text-stone-600">
            <p className="text-sm">
              <span className="font-semibold">Estimated time:</span> Approximately 2–5 minutes
            </p>
            <p className="text-xs mt-1">
                (You can save progress and return at any time.)
            </p>
          </div>
        </div>
      </ResponsiveContent>

      <ResponsiveFooter
        title="Confirm Plan Access"
        subtitle="Manage who can access your plan"
        progressPercent={0}
        onNext={handleNext}
        onBack={handleBack}
        nextText="Get Started"
        backText="Back to Dashboard"
      />
    </ResponsiveContainer>
  );
};

export default Frame301;
